module.exports = __webpack_public_path__ + "static/mondays-team-bffeaacbae8e5c5fa3cabfe87b6188d7.svg";